const getWhitePitch = (state = false, action)=>{
    if(action.type === "SET_WHITE_PITCH"){
        state = action.state
    }

    return state;
}

export default getWhitePitch;